if (!customElements.get('product-card-switcher')) {
  class ProductCardSwitcher extends HTMLElement {
    constructor() {
      super();
      this.switchButtons = this.querySelectorAll('[data-product-switcher-button]');

      // Catch click events on the switch buttons
      this.switchButtons.forEach((switchButton) => {
        switchButton.addEventListener('click', this.OnSwitch.bind(switchButton));
      });
    }

    OnSwitch() {
      const productSwitcherInner = this.closest('[data-product-card]');
      productSwitcherInner
        .querySelectorAll('[data-product-switcher-button]')
        .forEach((switchButton) => {
          // Remove the active class from the all buttons
          switchButton.classList.remove('active');
        });

      // Set the active class on the clicked button
      this.classList.add('active');

      // Get all elements in the product card that need to be updated
      const title = productSwitcherInner.querySelector('[data-product-card-title]');
      const primaryImage = productSwitcherInner.querySelector('.product-card__image--primary');
      const secondaryImage = productSwitcherInner.querySelector('.product-card__image--secondary');
      const links = productSwitcherInner.querySelectorAll('a');

      // Update the product card with the new product data
      title.textContent = this.dataset.productTitle;
      primaryImage.removeAttribute('loading');
      primaryImage.setAttribute('src', this.dataset.productPrimaryImage);
      primaryImage.setAttribute('srcset', this.dataset.productPrimaryImage);

      if (secondaryImage) {
        secondaryImage.removeAttribute('loading');
        secondaryImage.setAttribute('src', this.dataset.productSecondaryImage);
        secondaryImage.setAttribute('srcset', this.dataset.productSecondaryImage);
      }

      links.forEach((link) => {
        link.href = this.dataset.productUrl;
        link.title = this.dataset.productTitle;
      });
    }
  }
  customElements.define('product-card-switcher', ProductCardSwitcher);
}
